// Chemin: C:\gestion-copro\src\pages\public\InscriptionConfirmationPage.tsx
// Page de confirmation apres inscription - ORION PILOT
// Session 8

import React from 'react';
import { useNavigate } from 'react-router-dom';

const InscriptionConfirmationPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md text-center">
        
        <div className="text-green-500 text-6xl mb-4">✓</div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Inscription enregistree
        </h1>
        
        <p className="text-gray-600 mb-6">
          Votre demande d'inscription a bien ete enregistree.
          Le conseil syndical va verifier vos informations et valider votre compte.
        </p>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800">
            <strong>Delai de validation :</strong> 24 a 48 heures
          </p>
          <p className="text-sm text-blue-700 mt-2">
            Vous recevrez un email une fois votre compte valide.
          </p>
        </div>
        
        <button
          onClick={() => navigate('/login')}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Retour a la connexion
        </button>
        
      </div>
    </div>
  );
};

export default InscriptionConfirmationPage;